import { useState } from "react";
import "./style.css";
import { useIntl } from "react-intl";
import { IconHamburger, LocaleSelector, logo } from "./shared";
import banner from "../assets/images/s3.png";

const desktopNavItems = [
  { href: "/metuaa-mapper", label: "METUA'A MAPPER", messageId: "header.nav.mapper", cls: "gTNDXf" },
  { href: "/metuaa", label: "METUA'A", messageId: "Metua'a", cls: "gTNDXf" },
  { href: "/metuaa-eat", label: "METUA'A EATS", messageId: "header.nav.eat", cls: "gTNDXf" },
  { href: "/metuaa-travel-hub", label: "METUA'A TRAVEL HUB", messageId: "header.nav.travel", cls: "gTNDXf" },
  { href: "/metuaa-buy", label: "METUA'A Empowers Your", messageId: "header.nav.buy", cls: "gTNDXf" },
 
  { href: "/all-driver", label: "DRIVER", messageId: "header.nav.driver", cls: "gTNDXh" },
  { href: "/all-ride", label: "RIDER", messageId: "header.nav.rider", cls: "gTNDXg" },
  { href: "/all-enterprise", label: "/business", messageId: "header.nav.business", cls: "gTNDXe" },
];

const topBarLinks = [
  { href: "/all-ride", messageId: "header.nav.rider" },
  { href: "/all-driver", messageId: "header.nav.driver" },
  { href: "/all-enterprise", messageId: "header.nav.business" },
];

function isActiveMenuItem(currentPath, href) {
  return currentPath === href || currentPath.startsWith(`${href}/`);
}

function TopBar() {
  const intl = useIntl();
  const currentPath = typeof window !== "undefined" ? window.location.pathname : "";

  return (
    <>
      <style>{`
        :root {
          --topbar-height: 40px;
          --topbar-bg: #0c6f3f;
          --topbar-text: #ffffff;
          --topbar-font-size: 13px;
          --topbar-padding-right: 8em;
        }
        .site-topbar {
          width: 100%;
          height: var(--topbar-height);
          background: var(--topbar-bg);
          box-sizing: border-box;
          font-size: var(--topbar-font-size);
          color: var(--topbar-text);
          position: fixed;
          top: 0;
          left: 0;
          z-index: 402;
        }
        .site-topbar__inner {
          max-width: 1440px;
          margin: 0 auto;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          gap: 24px;
          padding-right: 8px;
          padding-left: 16px;
         /*  padding: 0 18em 0 32px; */
          box-sizing: border-box;
        }
        @media (min-width: 768px) {
          .site-topbar__inner {
            padding-left: 24px;
          }
        }
        .site-topbar__link {
          color: var(--topbar-text);
          text-decoration: none;
          font-weight: 500;
          white-space: nowrap;
        }
        .site-topbar__link:hover {
          text-decoration: underline;
          color: var(--topbar-text);
        }
        .site-topbar__link.is-active {
          font-weight: 700;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .site-topbar__separator {
          width: 1px;
          height: 14px;
          background: rgba(255, 255, 255, 0.35);
        }
        .site-topbar__locale {
          display: inline-flex;
          align-items: center;
          gap: 4px;
          color: var(--topbar-text);
          cursor: pointer;
        }

        .site-topbar .site-language-selector {
          min-height: 28px;
          padding: 4px 8px;
          transform: scale(0.85);
          transform-origin: right center;
        }

        .site-topbar .site-language-selector__trigger,
        .site-topbar .site-language-selector__caretButton {
          min-height: 28px;
        }

        @media (max-width: 640px) {
          .site-topbar__inner {
            gap: 12px;
          }
          .site-topbar__link--optional,
          .site-topbar__link--optional + .site-topbar__separator {
            display: none;
          }
        }
      `}</style>

      <div className="site-topbar">
        <div className="site-topbar__inner">
          {topBarLinks.map((link, i) => (
            <span key={link.href} style={{ display: "inline-flex", alignItems: "center", gap: "24px" }}>
              <a
                href={link.href}
                className={`site-topbar__link${i < topBarLinks.length - 1 ? " site-topbar__link--optional" : ""}${isActiveMenuItem(currentPath, link.href) ? " is-active" : ""}`}
              >
                {intl.formatMessage({ id: link.messageId })}
              </a>
              {i < topBarLinks.length - 1 && <span className="site-topbar__separator" />}
            </span>
          ))}

          <span className="site-topbar__separator" />

          <a
            href="/signin-all"
            className={`site-topbar__link${isActiveMenuItem(currentPath, "/signin-all") ? " is-active" : ""}`}
          >
            {intl.formatMessage({ id: "header.nav.login" })}
          </a>

          <span className="site-topbar__separator" />

          <LocaleSelector />
        </div>
      </div>
    </>
  );
}

export default function Header() {
  const intl = useIntl();
  const currentPath = typeof window !== "undefined" ? window.location.pathname : "";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <>

    <header>
      <style>{`
        /* App.js already applies a global zoom:0.8 to the whole app. This
           header used to add its OWN zoom:0.8 on top of that, compounding
           to 0.64x — that shrank the hamburger button (32px tall to start
           with) down to ~20px, well under the ~44px touch target size
           mobile browsers need to register taps reliably. That's why the
           mobile menu button felt unresponsive: it was too small to tap
           consistently. Removed the extra zoom and enlarge the tap target
           below 1024px instead. */
        @media (max-width: 1023px) {
          .fTJiqd {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 44px;
            min-height: 44px;
            padding: 6px;
          }
        }
        .mobile-nav-panel {
          width: 100%;
          background: #fff;
          border-top: 1px solid rgba(31, 18, 33, 0.08);
          box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
        }
        .mobile-nav-panel ul {
          list-style: none;
          margin: 0;
          padding: 8px 24px 16px;
          display: flex;
          flex-direction: column;
        }
        .mobile-nav-panel a {
          display: block;
          padding: 14px 4px;
          font-weight: 700;
          font-size: 15px;
          color: #1f1221;
          text-decoration: none;
          border-bottom: 1px solid rgba(31, 18, 33, 0.06);
        }
        .mobile-nav-panel a.is-active {
          color: #0c6f3f;
        }
        @media (min-width: 1024px) {
          .ivHlJC {
            width: 100%;
          }
          .bcklQT {
            width: 100%;
          }
          .jLnuvr,
          .keKQgy {
            padding-right: 0;
          }
          .ggbPbB {
            width: 100%;
            justify-content: flex-end;
          }
          .mobile-nav-panel {
            display: none;
          }
        }
      `}</style>
      <TopBar />
      <div className="sc-laNGHT kVtRyo" />
      <div className="sc-pKqro cWTHFF" style={{ top: "var(--topbar-height, 40px)" }}>
        <div className="sc-cHMHOW gTpcvJ">
          <div data-testid="core-ui-layout-grid" className="sc-satoz eEJPJx">
            <div data-testid="core-ui-layout-container" className="sc-isRoRg keKQgy">
              <div className="sc-gvPdwL vaMkw">
                <a className="bbc-logo" aria-label={intl.formatMessage({ id: "header.logo.ariaLabel" })} href="/">
                  <img src={logo} alt={intl.formatMessage({ id: "header.logo.alt" })} className="bbc-logo-image" />
                  
                </a>
              </div>
            </div>

            <div data-testid="core-ui-layout-container" className="sc-isRoRg jLnuvr">
              <div className="sc-djVXDX ivHlJC">
                <nav data-testid="DesktopNavigation" className="sc-DWsrX bcklQT">
                  <ul className="sc-iLWXdy ggbPbB">
                    {desktopNavItems
                    .filter((item) => !["/all-driver", "/all-ride", "/all-enterprise"].includes(item.href))
                    .map((item) => (
                      <li key={item.href} className={`sc-eONNys ${item.cls}`}>
                        <div data-testid="core-ui-spacer" className="sc-gsFSXq erCIOG" />
                        <a href={item.href}
                          data-tracking-category="menu"
                          data-tracking-label={item.label}
                          className={`sc-gFnajm hpccuJ header-nav-link${isActiveMenuItem(currentPath, item.href) ? " is-active" : ""}`}
                        >
                          <span data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">
                            {intl.formatMessage({ id: item.messageId })}
                          </span>
                        </a>
                        <div data-testid="core-ui-spacer" className="sc-gsFSXq erCIOG" />
                      </li>
                    ))}

                    {/* <li className="sc-eONNys bfOsFp">
                      <div data-testid="core-ui-spacer" className="sc-gsFSXq erCIOG" />
                      
                      <a  href="/signin-all"
                        data-tracking-category="menu"
                        data-tracking-label="Log In"
                        className={`sc-gFnajm hpccuJ header-nav-link${isActiveMenuItem("/signin-all") ? " is-active" : ""}`}
                      >
                        <span data-testid="core-ui-text" className="sc-bmzYkS ihhpyF">
                          {intl.formatMessage({ id: "header.nav.login" })}
                        </span>
                      </a>
                      <div data-testid="core-ui-spacer" className="sc-gsFSXq erCIOG" />
                    </li> */}

                    {/* <li className="sc-eONNys bfOsFp">
                      <div data-testid="core-ui-spacer" className="sc-gsFSXq erCIOG" />
                      <LocaleSelector />
                      <div data-testid="core-ui-spacer" className="sc-gsFSXq eVrKIz" />
                    </li> */}
                  </ul>
                </nav>

                <div className="sc-kuVLHQ jdOson">
                  <button
                    type="button"
                    aria-label={intl.formatMessage({ id: "header.mobileMenu.open" })}
                    aria-hidden="false"
                    aria-expanded={isMobileMenuOpen}
                    data-tracking-category="menu"
                    data-tracking-value="Hamburger Button"
                    className="sc-epRvzc fTJiqd"
                    onClick={() => setIsMobileMenuOpen((open) => !open)}
                  >
                    <span data-testid="core-ui-icon" className="sc-jEACwC cfWAWk">
                      <IconHamburger />
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <nav className="mobile-nav-panel" aria-label={intl.formatMessage({ id: "header.mobileMenu.open" })}>
          <ul>
            {desktopNavItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className={isActiveMenuItem(currentPath, item.href) ? "is-active" : ""}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {intl.formatMessage({ id: item.messageId })}
                </a>
              </li>
            ))}
            <li>
              <a href="/signin-all" onClick={() => setIsMobileMenuOpen(false)}>
                {intl.formatMessage({ id: "header.nav.login" })}
              </a>
            </li>
          </ul>
        </nav>
      )}
    </header>
    <div style={{ width: "100%", height: "60px", marginTop: "-5px", position: "relative" }}>
      <img
        src={banner}
        alt={intl.formatMessage({ id: "header.logo.alt" })}
        className="w-full h-full"
        style={{ position: "fixed", top: "116px", left: 0, width: "100%", height: "60px", zIndex: 399 }}
      />
    </div>

    </>
    
  );
}
